"use strict";

require("core-js/modules/es.array.iterator");

var zipL = require('../Lazy/zipL.js');

var curry = require('./curry.js');

var map = require("./map.js");

module.exports = curry(function zipWith(f, ...iterables) {
  return map(group => f(...group), zipL(...iterables));
});